import { render, staticRenderFns } from "./WhiteBoard.vue?vue&type=template&id=162b6f5e&scoped=true&"
import script from "./WhiteBoard.vue?vue&type=script&lang=js&"
export * from "./WhiteBoard.vue?vue&type=script&lang=js&"
import style0 from "./WhiteBoard.vue?vue&type=style&index=0&id=162b6f5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162b6f5e",
  null
  
)

export default component.exports